import Resource from 'api/resource';

class SOPsResource extends Resource {
  constructor() {
    super('company-sop/');
  }
}

export { SOPsResource as default };
